import { createContext, useContext, useState } from "react";
import { translations } from "@/lib/translations";

const I18nContext = createContext(null);

export const I18nProvider = ({ children }) => {
  const [lang, setLang] = useState(localStorage.getItem("securiprot_lang") || "fr");

  const toggleLang = () => {
    const next = lang === "fr" ? "en" : "fr";
    setLang(next);
    localStorage.setItem("securiprot_lang", next);
  };

  const t = (key) => {
    const parts = key.split(".");
    let val = translations;
    for (const part of parts) val = val?.[part];
    if (val && typeof val === "object") return val[lang] ?? val.fr ?? key;
    return key;
  };

  return <I18nContext.Provider value={{ lang, toggleLang, t }}>{children}</I18nContext.Provider>;
};

export const useI18n = () => useContext(I18nContext);
